<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18 3.59998C10.0512 3.59998 3.59998 10.0512 3.59998 18C3.59998 25.9488 10.0512 32.4 18 32.4C25.9488 32.4 32.4 25.9488 32.4 18C32.4 10.0512 25.9488 3.59998 18 3.59998ZM18.0001 8.60867C20.4251 8.60867 22.3827 10.5662 22.3827 12.9913C22.3827 15.4163 20.4251 17.3739 18.0001 17.3739C15.575 17.3739 13.6175 15.4163 13.6175 12.9913C13.6175 10.5662 15.575 8.60867 18.0001 8.60867ZM8.60857 24.1995C11.2462 26.9213 14.5041 28.7171 18.2944 28.7171C22.0847 28.7171 25.4354 26.9213 27.3912 24.1995C27.3457 21.4075 21.3115 19.8782 18.2944 19.8782C15.2622 19.8782 8.65405 21.4075 8.60857 24.1995Z"
      :fill="color"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#6E6055",
    },
    size: {
      type: Number,
      default: 36,
    },
  },
};
</script>
